import { createReducer, on } from '@ngrx/store';
import * as exportedDataActions from '../actions/exported-data.action';
import { PagedOrders } from 'src/app/core/orders/models/orders.models';
import { ExportedDataState } from '../../models/exported-data.model';

export const initialState: ExportedDataState = {
  data: null,
  isLoading: false,
  error: null,
  filters: {
    service_id: null,
    cash_status: null,
    date: null,
    from: null,
    to: null,
    status_id: null,
    rider_id: null,
  },
};

export const exportedDataReducer = createReducer(
  initialState,
  on(exportedDataActions.updatedFilters, (state, { filters }) => ({
    ...state,
    filters: { ...state.filters, ...filters },
  })),
  on(exportedDataActions.cleanFilters, (state) => ({
    ...state,
    filters: {
      service_id: null,
      cash_status: null,
      date: null,
      from: null,
      to: null,
      status_id: null,
      rider_id: null,
    },
  })),
  on(exportedDataActions.cleanOneFilter, (state, { filter }) => ({
    ...state,
    filters: {
      ...state.filters,
      [filter]: null,
    },
  })),
  on(exportedDataActions.loadExportedData, (state) => ({
    ...state,
    isLoading: true,
    error: null,
  })),
  on(exportedDataActions.loadExportedDataSuccess, (state, { data }) => ({
    ...state,
    data,
    filters: {
      service_id: null,
      cash_status: null,
      date: null,
      from: null,
      to: null,
      status_id: null,
      rider_id: null,
    },
    isLoading: false,
  })),
  on(exportedDataActions.loadExportedDataFailure, (state, { error }) => ({
    ...state,
    error,
    isLoading: false,
  })),
  on(exportedDataActions.exportOrders, (state) => ({
    ...state,
    isLoading: true,
    error: null,
  })),
  on(exportedDataActions.exportOrdersSuccess, (state, { data }) => ({
    ...state,
    data,
    isLoading: false,
  })),
  on(exportedDataActions.exportOrdersFailure, (state, { error }) => ({
    ...state,
    error,
    isLoading: false,
  }))
);